import { useMemo } from "react";

import { specAtFocus, type AgentScope } from "@/features/agents/types";
import { useAgentSpecs } from "@/features/agents/useAgentSpecs";
import { useMatterStarters } from "@/features/agents/useMatterStarters";

const NO_STARTERS: readonly string[] = [];

/**
 * The case agent's starters: what is pressing on the case (a deadline, an
 * RFE, the next early step) from `case_agent/starters.py`, with the spec's
 * static list as the fallback. The composer's empty state and the editor's
 * Nothing open share them.
 */
export const useCaseStarters = (individualId: string) => {
  const { specFor } = useAgentSpecs();
  const scope = useMemo<AgentScope>(
    () => ({ kind: "case", id: individualId }),
    [individualId]
  );
  const caseSpec = specFor("assistant");
  const fallback = useMemo(
    () => (caseSpec ? specAtFocus(caseSpec, "case").starters : NO_STARTERS),
    [caseSpec]
  );
  return { scope, ...useMatterStarters(scope, fallback) };
};
